import styled from "styled-components";

export const InlineText = styled.span`
    color: ${props => props.theme.colors.lightText}
`;

export const PathContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 8px;
    margin-bottom: 8px;
    gap: 4px;
`;

export const PathItem = styled.span`
    color: ${props => props.isLast ? '#1890ff' : '#595959'};
    font-weight: ${props => props.isLast ? 600 : 400};
    font-size: 13px;
    white-space: nowrap;
    transition: color 0.2s;
    
    &:hover {
        color: ${props => props.isLast ? '#40a9ff' : '#1890ff'};
    }
`;

export const PathSeparator = styled.span`
    color: #bfbfbf;
    font-size: 12px;
    display: flex;
    align-items: center;
    margin: 0 2px;
`;

export const AttributesContainer = styled.div`
    margin-top: 12px;
    
    .ant-descriptions-item-label {
        font-weight: 600;
    }
    
    .ant-descriptions-item-content {
        word-break: break-word;
    }
`;